// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-left[data-v-db24aa3a]{text-align:left}.answer-title[data-v-db24aa3a]{padding:15px;color:#2cb774}", ""]);
// Exports
module.exports = exports;
